import { Link } from 'react-router-dom';

export default function Privacy() {
  return (
    <article className="prose mx-auto max-w-2xl px-6 py-12 text-slate-700">
      <Link to="/" className="text-sm text-slate-500 hover:text-slate-700">
        ← Home
      </Link>
      <h1 className="mt-4 text-3xl font-semibold text-slate-900">Privacy</h1>
      <p className="mt-2 text-sm text-slate-500">
        Beta — last updated June 2026. Plain English; this isn't a finalized
        policy and there's no SLA yet. Email <a href="mailto:support@adhoc.space" className="text-brand-600 hover:underline">support@adhoc.space</a> if anything below is unclear.
      </p>

      <h2 className="mt-8 text-lg font-semibold text-slate-900">What we collect</h2>
      <ul className="mt-2 list-disc space-y-1 pl-6 text-sm">
        <li><strong>Account data:</strong> your email, your name, your workspace name.</li>
        <li><strong>Links you create:</strong> destination URL, slug, optional title, optional expiry/cap.</li>
        <li><strong>Click analytics:</strong> per redirect we store country, region, referrer hostname, browser family, device class, a daily-rotated IP hash, and a timestamp. We do not retain raw IP addresses.</li>
        <li><strong>Auth tokens:</strong> magic-link tokens and session tokens are stored hashed (SHA-256).</li>
      </ul>

      <h2 className="mt-8 text-lg font-semibold text-slate-900">Who else sees this data</h2>
      <ul className="mt-2 list-disc space-y-1 pl-6 text-sm">
        <li><strong>Cloudflare</strong> hosts the application (Workers, D1, KV, Turnstile).</li>
        <li><strong>Postmark</strong> delivers transactional email (sign-in links, invites).</li>
        <li>We don't sell or share data with anyone else.</li>
      </ul>

      <h2 className="mt-8 text-lg font-semibold text-slate-900">Cookies</h2>
      <p className="mt-2 text-sm">
        One first-party session cookie (<code className="rounded bg-slate-100 px-1">adhc_session</code>), HttpOnly + SameSite=Lax, 30-day TTL. No analytics or marketing cookies.
      </p>

      <h2 className="mt-8 text-lg font-semibold text-slate-900">Deleting your data</h2>
      <p className="mt-2 text-sm">
        Email <a href="mailto:support@adhoc.space" className="text-brand-600 hover:underline">support@adhoc.space</a> from your account address and we'll delete your workspace and its links/clicks within 30 days. A self-service "Delete workspace" button is coming.
      </p>

      <h2 className="mt-8 text-lg font-semibold text-slate-900">Children</h2>
      <p className="mt-2 text-sm">
        adhc.to is not directed at children under 16; please don't create an account if that's you.
      </p>

      <h2 className="mt-8 text-lg font-semibold text-slate-900">Changes</h2>
      <p className="mt-2 text-sm">
        We'll email beta users (and update this page) before any material change.
      </p>
    </article>
  );
}
